
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  @Component({
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class AcceptTerms extends Vue {
    @Prop()
    public isLowThresholdAgeGateBirthdaySoon!: boolean;

    @Prop()
    public dateOfBirthCreatedAt!: Date;

    data() {
      return {
        frontUrl: '',
        platformName: '',
        minimumAge: undefined,
        permanentlyDeletedWording: '',
        comeBackToReactivateWording: '',
        supportTeamMailHref: '',
      }
    };

    created() {
      this.$data.minimumAge = this.$store.getters.ageGateSettings.LowThresholdAge;
      this.$data.platformName = this.$data.RCEnvironment.VUE_APP_PLATFORM_NAME;

      const shortDelay: number = this.$store.getters.ageGateSettings.DaysBeforeDeleteShortDelay;
      const countdownToDeletion: number = shortDelay - moment().diff(moment(this.dateOfBirthCreatedAt), 'days');

      if (countdownToDeletion === 0) {
        this.$data.permanentlyDeletedWording = 'It will be permanently deleted today.';
      }

      if (countdownToDeletion > 0) {
        this.$data.permanentlyDeletedWording = `It will be permanently deleted in ${countdownToDeletion} day${countdownToDeletion > 1 ? 's' : ''}.`;
      }

      this.$data.comeBackToReactivateWording = `<b>If you are in the year of your ${this.$data.minimumAge - 1}th birthday</b>, come back after your ${this.$data.minimumAge}th birthday to reactivate your account. <b>Otherwise, your data will be permanently deleted.</b>`;

      this.$data.frontUrl = this.$data.RCEnvironment.VUE_APP_FRONT_URL;
      this.$data.supportTeamMailHref = `mailto:${this.$data.RCEnvironment.VUE_APP_SUPPORT_TEAM_EMAIL}`;
    }
  }
